import JLink from './JLink';

export default JLink;
